import { render, staticRenderFns } from "./RenseignementsGeneraux.vue?vue&type=template&id=ee285b9c"
import script from "./RenseignementsGeneraux.vue?vue&type=script&lang=js"
export * from "./RenseignementsGeneraux.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports